module.exports = __webpack_public_path__ + "img/ic-qr-ph.a33508a5.png";